import { Card } from './Card';

export const components = {
  Card,
};
